import helpers from '../helpers';

class SvgSizes {
	constructor() {
		this.$svgElems = $('.svg-observe-sizes');
		this.watch();
		this.handler = helpers.throttle(this.watch.bind(this));
	}

	init() {
		window.addEventListener('resize', this.handler);
	}

	watch() {
		this.$svgElems.each(function () {
			$(this).attr('viewBox', `0 0 ${$(this).width()} ${$(this).height()}`);
			$(this).find('text').attr('y', $(this).height() * 0.83);
		});
	}
}

export default SvgSizes;
